module.exports = __webpack_public_path__ + "static/img/travelTreasuryiPhone.fe947f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/travelTreasuryiPhone.png
// module id = cdSj
// module chunks = 1